import styled from "styled-components";

export const Content = styled.div `

    display: grid;
    grid-template-columns: ${props => props?.maximized ? "repeat(6, 1fr)" : "repeat(4, 1fr)"};
    gap: 10px;
    
    @media (max-width: 1500px) {
        grid-template-columns: ${props => props?.maximized ? "repeat(5, 1fr)" : "repeat(4, 1fr)"};
    }
    
    @media (max-width: 1200px) {
        grid-template-columns: ${props => props?.maximized ? "repeat(4, 1fr)" : "repeat(3, 1fr)"};
    }
    
    @media (max-width: 800px) {
        grid-template-columns: ${props => props?.maximized ? "repeat(3, 1fr)" : "repeat(2, 1fr)"};
    }
    
    @media (max-width: 600px) {
        grid-template-columns: repeat(2, 1fr);
    }
`